import React from "react";

const FeaturesLotusCab = () => {
  return (
    <section className="lotus-features section-space">
      <div className="container">
        <h6 className="section-subtitle" style={{ textAlign: "center", fontWeight: "bold", color: "#ff7f00" }}>
          TRAVEL WITH LOTUS CAB
        </h6>
        <h2 className="section-title" style={{ textAlign: "center", marginBottom: "50px" }}>
          Experience Seamless Rides With Lotus Cab
        </h2>

        <div className="features-grid" style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "40px" }}>
          
          <div className="feature-item" style={{ flex: "1 1 45%", minWidth: "280px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
              <div style={{
                backgroundColor: "#ff7f00",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: "bold",
                marginRight: "15px",
              }}>
                &rarr;
              </div>
              <h3 style={{ margin: 0 }}>Wide Range Of Vehicles</h3>
            </div>
            <p style={{ color: "#666" }}>
              From Economy Rides To Luxury Cars, Lotus Cab Offers A Variety Of Vehicles To Suit Every Journey And Budget.
            </p>
          </div>

          <div className="feature-item" style={{ flex: "1 1 45%", minWidth: "280px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
              <div style={{
                backgroundColor: "#ff7f00",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: "bold",
                marginRight: "15px",
              }}>
                &rarr;
              </div>
              <h3 style={{ margin: 0 }}>Instant Booking & Emergency Rides</h3>
            </div>
            <p style={{ color: "#666" }}>
              With Real-Time Tracking And Quick Pickup Options, Lotus Cab Ensures You're Never Left Waiting — Day Or Night.
            </p>
          </div>

          <div className="feature-item" style={{ flex: "1 1 45%", minWidth: "280px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
              <div style={{
                backgroundColor: "#ff7f00",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: "bold",
                marginRight: "15px",
              }}>
                &rarr;
              </div>
              <h3 style={{ margin: 0 }}>Experienced & Professional Drivers</h3>
            </div>
            <p style={{ color: "#666" }}>
              Our Drivers Are Background-Checked, Well-Trained, And Committed To Providing You With A Safe And Courteous Ride.
            </p>
          </div>

          <div className="feature-item" style={{ flex: "1 1 45%", minWidth: "280px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
              <div style={{
                backgroundColor: "#ff7f00",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#fff",
                fontWeight: "bold",
                marginRight: "15px",
              }}>
                &rarr;
              </div>
              <h3 style={{ margin: 0 }}>Affordable & Transparent Pricing</h3>
            </div>
            <p style={{ color: "#666" }}>
              No Hidden Fees, No Surprises. Just Fair, Upfront Rates That Work For Every Passenger.
            </p>
          </div>

        </div>

        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <img 
            src="assets/images/resources/lotus-car.png" 
            alt="Lotus Cab Car" 
            style={{ maxWidth: "300px", borderRadius: "10px" }} 
          />
        </div>
      </div>
    </section>
  );
};

export default FeaturesLotusCab;
